
define('app/users/pwreset/pwResetMain',[
	'domReady',
	'app/users/pwreset/pwResetApp',
	'app/common/setup',
	'unknown/unknownSetup'
], function(domReady, PwResetApp, Setup, UnknownSetup){
	domReady(function () {
		Setup.initialize();
		PwResetApp.initialize();
		UnknownSetup.initialize();
    });
});